import { writable } from 'svelte/store';

export const USER = writable({});
export const CLIENTE = writable('')
